// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchLoanReports } from "../redux/slices/loanReportSlice";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./AppliedLoanTest.css";
// import axios from "axios";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];
// const API_URL = "https://payyug.in/api/";

// const LoanReport = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { loans, loading, error } = useSelector((state) => state.loanReport);

//   const [filterData, setFilterData] = useState({
//     fromDate: "",
//     toDate: "",
//     loanAccountNumber: "",
//     userId: "",
//     userName: "",
//     loanStatus: "",
//   });

//   const [filteredLoans, setFilteredLoans] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   useEffect(() => {
//     dispatch(fetchLoanReports());
//   }, [dispatch]);

//   useEffect(() => {
//     // Show only loans with status = "pending" (case-insensitive)
//     setFilteredLoans(
//       loans.filter((loan) => loan.status?.toLowerCase() === "pending")
//     );
//     setCurrentPage(1);
//   }, [loans]);

//   useEffect(() => {
//     if (error) {
//       toast.error(`Error: ${error}`);
//     }
//   }, [error]);

//   const handleChange = (e) => {
//     setFilterData({ ...filterData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const filtered = loans.filter((loan) => {
//       const { fromDate, toDate, loanAccountNumber, userId, userName } =
//         filterData;
//       const appliedDate = new Date(loan.appliedDate);

//       return (
//         loan.status?.toLowerCase() === "pending" &&
//         (!fromDate || appliedDate >= new Date(fromDate)) &&
//         (!toDate || appliedDate <= new Date(toDate)) &&
//         (!loanAccountNumber ||
//           loan.loanAccountNumber
//             ?.toLowerCase()
//             .includes(loanAccountNumber.toLowerCase())) &&
//         (!userId || loan.userId?.toString() === userId) &&
//         (!userName ||
//           loan.userName?.toLowerCase().includes(userName.toLowerCase()))
//       );
//     });

//     setFilteredLoans(filtered);
//     setCurrentPage(1);
//   };

//   const handleApproveLoan = async (loan) => {
//     // Confirmation popup
//     const confirmApprove = window.confirm(
//       `Do you want to approve loan ${loan.loanAccountNumber}?`
//     );
//     if (!confirmApprove) return;

//     if (loan.status?.toLowerCase() === "approved") {
//       toast.info("Loan is already Approved");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${API_URL}approveLoan-personal/${loan.id}/approve`,
//         { approvalRemark: "Verified documents" }
//       );

//       toast.success(response.data.message);
//       dispatch(fetchLoanReports());
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to approve loan");
//     }
//   };

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")} ${String(
//       date.getHours()
//     ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//   };

//   const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentLoans = filteredLoans.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="applied-loan-container">
//       {/* Filter Section */}
//       <section className="applied-loan-filter-section">
//         <h2 className="applied-loan-title">Applied Loans Filter</h2>
//         <p className="applied-loan-subtitle">
//           Use filter to see more precise report
//         </p>
//         <form className="applied-loan-form" onSubmit={handleSubmit}>
//           <div className="applied-loan-grid">
//             <div className="applied-loan-form-group">
//               <label>From Date</label>
//               <input type="date" name="fromDate" onChange={handleChange} />
//             </div>
//             <div className="applied-loan-form-group">
//               <label>To Date</label>
//               <input type="date" name="toDate" onChange={handleChange} />
//             </div>
//             <div className="applied-loan-form-group">
//               <label>Loan Account Number</label>
//               <input
//                 type="text"
//                 name="loanAccountNumber"
//                 placeholder="Loan account number"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="applied-loan-form-group">
//               <label>Applicant User ID</label>
//               <input
//                 type="text"
//                 name="userId"
//                 placeholder="Applicant user id"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="applied-loan-form-group">
//               <label>Applicant User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 placeholder="Applicant user name"
//                 onChange={handleChange}
//               />
//             </div>
//           </div>
//           <button type="submit" className="applied-loan-submit-btn">
//             Submit
//           </button>
//         </form>
//       </section>

//       {/* Loan Details Section */}
//       <section className="applied-loan-details-section">
//         <div className="applied-loan-table-header">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                 <option key={count} value={count}>
//                   {count}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//         </div>

//         <div className="applied-loan-table-container">
//           <table className="applied-loan-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Loan Status</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 <th>View EMI</th>
//                 <th>Loan Card</th>
//                 <th>Approve Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="17">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="17">Error: {error}</td>
//                 </tr>
//               ) : currentLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="17">No pending loans available</td>
//                 </tr>
//               ) : (
//                 currentLoans.map((loan, index) => (
//                   <tr key={loan.id}>
//                     <td>{startIndex + index + 1}</td>
//                     <td>{loan.loanAccountNumber || "N/A"}</td>
//                     <td>{loan.userName || "N/A"}</td>
//                     <td>{loan.loanAmount || "N/A"}</td>
//                     <td>{loan.loanInterest || "N/A"}</td>
//                     <td>{loan.loanTenure || "N/A"}</td>
//                     <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                     <td>{formatDate(loan.loanAppliedDate)}</td>
//                     <td>{loan.status || "N/A"}</td>
//                     <td>{loan.loanPayable || "N/A"}</td>
//                     <td>{loan.loanType || "N/A"}</td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//                       >
//                         View EMI
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/LoanCardPage/${loan.id}`)}
//                       >
//                         Loan Card
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => handleApproveLoan(loan)}
//                         style={{
//                           marginLeft: "6px",
//                           background: "#1f8b94ff",
//                           color: "#fff",
//                           padding: "5px 10px",
//                           border: "none",
//                           borderRadius: "4px",
//                         }}
//                       >
//                         Approve Loan
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Controls */}
//         {totalPages > 1 && (
//           <div className="applied-loan-pagination">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </section>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default LoanReport;

/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AppliedLoanTest.css";

const ITEMS_PER_PAGE_OPTIONS = [50, 100, 200];
const API_URL = "https://payyug.in/api";

const AapliedLoanTest = () => {
  const navigate = useNavigate();

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [loans, setLoans] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [approvalModal, setApprovalModal] = useState(false);
  const [selectedLoanForApproval, setSelectedLoanForApproval] = useState(null);

  /* ================= FETCH Branch ================= */

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "10000",
          },
        });
        // console.log("branch data", res.data);
        setBranchs(res?.data.branches);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  // console.log("slected branch",selectedBranch?.id)
  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) return;
    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch?.id,
            limit: 10000,
          },
        });

        // console.log("center list", res.data?.data);

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedCenter?.id) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId: selectedCenter.id,
          },
        });
        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter]);

  /* ================= FETCH LOANS ================= */
  const fetchLoans = async (page = 1, limit = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(
        `${API_URL}/group-loan/group/list?status=pending`,
        {
          params: {
            superAdminId,
            branchId: selectedBranch?.id,
            centerId: selectedCenter?.id,
            groupId: selectedGroup?.id,
            page,
            limit: "10000",
          },
          headers: { Authorization: `Bearer ${token}` },
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache', 
        }
      );

      setLoans(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
      setCurrentPage(res.data?.currentPage || 1);
    } catch (err) {
      setError("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };



  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();
    
   if (!selectedBranch || !selectedCenter || !selectedGroup) {
        toast.error("Please select Branch, Center, and Group before filtering.");
        return;
      }
  
      setCurrentPage(1);
      fetchLoans(1, rowsPerPage);
  };


 
  /* ================= ACTIONS ================= */
  const handleApproveLoan = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.post(
        `${API_URL}/group-loan/group/approve`,
        {
          // groupId: selectedLoanForApproval.groupId,
           groupId: selectedGroup.id,
          approvedBy: localStorage.getItem("adminuserId"),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(res.data.message || "Loan Approved");
      setApprovalModal(false);
      setSelectedLoanForApproval(null);
      fetchLoans(currentPage);
    } catch (err) {
      toast.error(err.response?.data?.message || "Approval failed");
    }
  };

  /* ================= ITEMS PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    const newLimit = Number(e.target.value);
    setRowsPerPage(newLimit);
    setCurrentPage(1);

    if (selectedBranch && selectedCenter && selectedGroup) {
      fetchLoans(1, newLimit);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  return (
    <div className="applied-loan-container">
      {/* Filter Section */}
      <section className="applied-loan-filter-section">
        {/* <h2 className="applied-loan-title">Applied Loans Filter</h2>
        <p className="applied-loan-subtitle">
          Use filter to see more precise report
        </p> */}
        <form className="applied-loan-form" onSubmit={handleSubmit}>
          <div className="applied-loan-grid">
            {/* Branch */}
            <div className="applied-loan-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value)
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null); // reset
                  setSelectedGroup(null); // reset
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="applied-loan-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const center = centers.find(
                    (cn) => cn.id === Number(e.target.value)
                  );
                  setSelectedCenter(center);
                  setSelectedGroup(null); // reset
                }}
              >
                <option value="">Select Center</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="applied-loan-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedBranch || !selectedCenter}
                onChange={(e) => {
                  const group = groups.find(
                    (gr) => gr.id === Number(e.target.value)
                  );
                  setSelectedGroup(group);
                }}
              >
                <option value="">Select Group</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>
          </div>
           <div className="filterbtnal">
               <button type="submit" className="applied-loan-submit-btn">
                    Filter
                  </button>
                  <button
                    onClick={() => {
                      // console.log(loan)
                      // setSelectedLoanForApproval(loan);
                      setApprovalModal(true);
                    }}
                    // style={{
                    //   marginLeft: "6px",
                    //   background: "#1f8b94ff",
                    //   color: "#fff",
                    //   padding: "5px 10px",
                    //   border: "none",
                    //   borderRadius: "4px",
                    // }}
                  >
                    Approve Loan
                </button>
           </div>
        </form>
      
      
                   
      </section>

      {/* Loan Details Section */}
      <section className="applied-loan-details-section">
        <div className="applied-loan-table-header">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="applied-loan-table-container">
          <table className="applied-loan-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Loan Amount</th>
                <th>Interest Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Loan Status</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                {/* <th>View EMI</th>
                <th>Loan Card</th> */}
                {/* <th>Approve Action</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="17">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="17">Error: {error}</td>
                </tr>
              ) : loans.length === 0 ? (
                <tr>
                  <td colSpan="17">No pending loans available</td>
                </tr>
              ) : (
                loans.map((loan, index) => (
                  <tr key={loan.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{loan.loanAccountNumber || "N/A"}</td>
                    <td>{loan.memberName || "N/A"}</td>
                    <td>{loan.loanAmount || "N/A"}</td>
                    <td>{loan.loanInterest || "N/A"}</td>
                    <td>{loan.loanTenure || "N/A"}</td>
                    <td>{loan.loanRecoveryFrequency || "N/A"}</td>
                    <td>{new Date(loan.loanAppliedDate).toLocaleDateString("en-GB")}</td>
                    <td>{loan.status || "N/A"}</td>
                    <td>{loan.loanPayable || "N/A"}</td>
                    <td>{loan.loanType || "N/A"}</td>
                    {/* <td>
                      <button
                        onClick={() => navigate(`/GroupLoanReport/ViewLoanEmi`)}
                      >
                        View EMI
                      </button>
                    </td>
                    <td>
                      <button
                        onClick={() => navigate(`/GroupLoanReport/LoanCard`)}
                      >
                        Loan Card
                      </button>
                    </td> */}
                  
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="applied-loan-pagination">
          <button
            onClick={() => {
              const newPage = currentPage - 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => {
              const newPage = currentPage + 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* ================= APPROVAL MODAL ================= */}
      {approvalModal && (
        <div className="applied-loan-modal-dialog-overlay">
          <div className="applied-loan-modal-dialog">
            <h3>Confirm Loan Approval</h3>
            <div className="applied-loan-modal-dialog-buttons">
              <button
                className="applied-loan-modal-btn-confirm"
                onClick={handleApproveLoan}
              >
                Approve
              </button>
              <button
                className="applied-loan-modal-btn-cancel"
                onClick={() => setApprovalModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AapliedLoanTest;
